import { render } from "./StocchinoPlan.vue?vue&type=template&id=24fc4527"
import script from "./StocchinoPlan.vue?vue&type=script&lang=js"
export * from "./StocchinoPlan.vue?vue&type=script&lang=js"

import "./StocchinoPlan.vue?vue&type=style&index=0&id=24fc4527&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__